import { useEffect } from "react";
import { eventBus } from "./eventBus.js";
export default (function (eventName, listener) {
  useEffect(function () {
    eventBus.on(eventName, listener);
    return function () {
      eventBus.off(eventName, listener);
    };
  }, [eventName, listener]);
});